










































import {Component, Vue} from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {sendVerifyEmail, verify, verifySuccess} from "@/services/api"

@Component({
  components: {
    'yc-header': YcHeader
  },
})
export default class EmailVerify extends Vue {
  public email = '';
  public showHelp = false;
  public timer!: number;

  created(): void {
    this.email = String(this.$route.query.email);
    this.verify();
  }

  verify() {
    this.timer = setInterval(() => {
      verify({email: this.email}).then(res => {
        if(res.data.data !== '未验证通过') {
          clearInterval(this.timer);
          this.$message.success(this.$tx('settings.verify.emailVerifiedSuccessfully', '邮箱验证成功!'));
          this.$router.push('/home');
        }
      })
    },10000)
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  /**
   * 发送验证邮件
   */
  sendVerifyEmail(message: boolean = true) {
    sendVerifyEmail({email: this.email}).then(res => {
      message && this.$message.success(this.$tx('settings.verify.emailResentSuccessfully', '重新发送邮件成功！'))
    })
  }

  changeEmail() {
    clearInterval(this.timer);
    this.$prompt(this.$tx('settings.verify.newEmail', '新邮箱'), this.$tx('settings.verify.changeEmail', '更改邮箱'), {
      confirmButtonText: this.$tx('common.ok', '确定'),
      cancelButtonText: this.$tx('common.cancel', '取消'),
      closeOnClickModal: false,
      inputValue: this.email,
      inputValidator: (value: any,) => {
        if(!value) {
          return this.$tx('comp.pleaseEnterSenderEmailAddress', '请输入发件人邮箱地址')
        } else if (value.length > 200) {
          return this.$tx('settings.account.lengthCannotExceed200Characters', '长度不能超过200个字符');
        } else if (!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(value)) {
          return this.$tx('comp.pleaseEnterValidEmailAddress', '请输入正确的邮箱地址');
        } else {
          return true;
        }
      }
    }).then(({value}: any) => {
      this.sendVerifyEmail(true);
      this.email = value;
      this.$router.push(`/email/verify?email=${this.email}`);
    }).catch(() => {
      this.verify();
    });
  }
}
